/**
 * @param {unknown} value
 * @returns {asserts value}
 */
export const assert = (value) => {
  // eslint-disable-next-line no-console
  console.assert(value);
};
